// extracted by mini-css-extract-plugin
export default {"backgroundcon":"backgroundcon__Z2lwI","topbg":"topbg__Lxojt"};